<div class="working-time-details" [ngStyle]="{'top': top, 'left': left}">
    <div class="working-time-details__header"> 
        <div class="working-time-details__header-title">
            {{ 'WORKING_TIME_SCHEMA.TIME_DETAILS' | translate }}
        </div>
    </div>
    <div class="working-time-details__table">
        <div class="working-time-details__table-row">
            <div class="working-time-details__table-row-title">{{ 'GLOBAL.FROM' | translate}}</div>
            <div class="working-time-details__table-row-title">{{ 'GLOBAL.TO' | translate}}</div>
        </div>
        <div *ngIf="!isCompany && workingTimeSchema.isWorking">
            <div *ngIf="workingTimeSchema.fromTime1 && workingTimeSchema.toTime1" class="working-time-details__table-row">
                <div class="working-time-details__table-row-date">{{workingTimeSchema.fromTime1 | showDateFormat: 7}}</div>
                <div class="working-time-details__table-row-date">{{workingTimeSchema.toTime1 | showDateFormat: 7}}</div>
            </div>
            <div *ngIf="workingTimeSchema.fromTime2 && workingTimeSchema.toTime2" class="working-time-details__table-row">
                <div class="working-time-details__table-row-date">{{workingTimeSchema.fromTime2 | showDateFormat: 7}}</div>
                <div class="working-time-details__table-row-date">{{workingTimeSchema.toTime2 | showDateFormat: 7}}</div>
            </div>
            <div *ngIf="workingTimeSchema.fromTime3 && workingTimeSchema.toTime3" class="working-time-details__table-row">
                <div class="working-time-details__table-row-date">{{workingTimeSchema.fromTime3 | showDateFormat: 7}}</div>
                <div class="working-time-details__table-row-date">{{workingTimeSchema.toTime3 | showDateFormat: 7}}</div>
            </div>
            <div *ngIf="workingTimeSchema.fromTime4 && workingTimeSchema.toTime4" class="working-time-details__table-row">
                <div class="working-time-details__table-row-date">{{workingTimeSchema.fromTime4 | showDateFormat: 7}}</div>
                <div class="working-time-details__table-row-date">{{workingTimeSchema.toTime4 | showDateFormat: 7}}</div>
            </div>
            <div *ngIf="workingTimeSchema.fromTime5 && workingTimeSchema.toTime5" class="working-time-details__table-row">
                <div class="working-time-details__table-row-date">{{workingTimeSchema.fromTime5 | showDateFormat: 7}}</div>
                <div class="working-time-details__table-row-date">{{workingTimeSchema.toTime5 | showDateFormat: 7}}</div>
            </div>
        </div>
        <div *ngIf="!isCompany && !workingTimeSchema.isWorking">
            <div class="working-time-details__table-row">
                <div class="working-time-details__table-row-date">{{defaultStartHour}}</div>
                <div class="working-time-details__table-row-date">{{defaultEndHour}}</div>
            </div>
        </div>
        <div *ngIf="isCompany">
            <div class="working-time-details__table-row" *ngFor="let rangeHour of workingTimeSchema">
                <div class="working-time-details__table-row-date">{{rangeHour.from}}</div>
                <div class="working-time-details__table-row-date">{{rangeHour.to}}</div>
            </div>
        </div>
    </div>
</div>
